import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { NgwWowService } from "ngx-wow";
import { Subscription } from "rxjs/Subscription";
import { CiacService } from "../../servicios/ciac.service";
import { tileLayer, latLng, marker, icon } from "leaflet";
import { NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { environment } from '../../../environments/environment';
import * as L from 'leaflet'
import { title } from "process";
import { logging } from 'protractor';


@Component({
  selector: 'app-ciac',
  templateUrl: './ciac.component.html',
  styleUrls: ['./ciac.component.css']
})
export class CiacComponent implements OnInit {
  private wowSubscription: Subscription;
  @ViewChild("f", { static: false }) userFrm: NgForm;

  siteKey = environment.KEY_CAPTCHA;
  type = 'image';
  theme = 'Light';
  size2 = 'inline';
  lang = 'es';
  captcha = false;

  colonias: any[] = [];
  servicios: any[] = [];
  loading = true;

  master: any = {
    idsolicitud: 0,
    folio: "",
    IdServicio: "",
    idsexo: "1",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    email: "",
    telefono: "",
    calle: "",
    numero: "",
    Idcolonia: "",
    entre_calle_1: "",
    entre_calle_2: "",
    comentarios: "",
    longitud: "",
    latitud: ""
  };
  forma: any = { ...this.master };
  folio: any;
  idsolicitud: any;
  nombre = "";
  imageSrc: any;
  repeat = "no-repeat";
  posicion = "50% 50%";
  size = "cover";
 

  icon = icon({
    iconSize: [25, 41],
    iconAnchor: [13, 41],
    iconUrl: "./assets/markers/marker-icon.png",
    shadowUrl: "./assets/markers/marker-shadow.png"
  });
   markerIcon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    // specify the path here
    iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
  });
  styleMessage: string | undefined;

  private map: L.Map;
  private popup = L.popup();
  private marker = L.marker;


  constructor(
    private _ciacService: CiacService,
   // private wowService: NgwWowService
  ) {
   // this.wowService.init();
    this.getCatalogos();
    this.folio = "";
    this.idsolicitud = 0;
  }
/*
  ver = function (mapa:any) {
    const lat = mapa.latlng.lat;
    const lng = mapa.latlng.lng;
    this.layers = [marker([lat, lng], { icon: this.icon })];
    this.forma.latitud = lat;
    this.forma.longitud = lng;
    this.center = latLng(lat, lng);
  
  };
*/
  ngOnInit() {
    this.map = L.map('map').setView([27.486301815694823, -99.50901031494142], 17);
    const tiles = L.tileLayer("http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
      maxZoom: 20,
      subdomains: ["mt0", "mt1", "mt2", "mt3"],
      detectRetina: true
    })
    tiles.addTo(this.map)

    

   
   /* var singleMarker = L.marker([27.486301815694823, -99.50901031494142]);
    singleMarker.addTo(this.map)
*/ // var markers = new L.FeatureGroup();
    this.map.on("click", <LeafletMouseEvent>(e) => {

      let lat = e.latlng.lat;
      let lng = e.latlng.lng;
     
      var marker = L.marker([lat, lng], { draggable: true, icon: this.markerIcon }).addTo(this.map);
   

      this.forma.latitud  = lat;
      this.forma.longitud = lng;

      marker.on('click', deleteMarker)
     
    });

    const deleteMarker = (e) => {
        e.target.removeFrom(this.map)
      
    }
  

   /* this.wowSubscription = this.wowService.itemRevealed$.subscribe(
      (item: HTMLElement) => {
      
      }
    );
   */
  }

  getCatalogos() {
    this._ciacService.getCatalogosColonias().then((data:any)=>{
      this.colonias =  data;
     
    })
    this._ciacService.getCatalogosServicios().then((data: any) => {
      this.servicios = data;
     
    })
   /* this._ciacService.getCatalogos().subscribe(resp => {
      console.log(resp)
      this.colonias = resp[0].registros;
      this.servicios = resp[1].registros;
      this.loading = false;
    });*/
  }

 
  cambioImg(files: FileList) {
    this.nombre = "";
    this.imageSrc = "";
    this.forma.imagen = files.item(0);
    if (files.item(0)) {
      // Carga vista previa de imagen
      const file = files.item(0);
      const reader = new FileReader();
      reader.onload = e => {
        this.imageSrc = reader.result;
      };
      reader.readAsDataURL(file);
    }
    // ******
    if (files.length == 1) {
      this.nombre = files.item(0).name;
      this.nombre.substr(0, 6);
    }
  }

  validarEmail() {
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.forma.email)
    ) {
    } else {
      this.userFrm.form.controls["email"].setErrors({ incorrect: true });
    }
  }

  agregar(m:any) {
    if (this.forma.latitud == "" && this.forma.longitud == "") {
      Swal.fire({
        icon: "error",
        title: "Seleccione una ubicación.",
        text: "La seleccion de un punto en el mapa es obligatoria."
      });
    } else {
      this.loading = true;
      this._ciacService
    
        .agregarSolicitud2(this.forma, this.forma.imagen)
        .then((data:any) => {
           
            if (data.idinsercion > 0) {
              this.idsolicitud = data.idinsercion;
            
              this.folio = data.folio;
              this.loading = false;
              m.show();
              this.forma = { ...this.master };
            } else {
              Swal.fire({
                icon: "error",
                title: "No se puedo agregar la solicitud.",
                text: "Error en insercion, favor de interntarlo de nuevo."
              });
              this.loading = false;
            }
          },
          err => {
            Swal.fire({
              icon: "error",
              title: "No se puedo agregar la solicitud.",
              text: "Error en insercion, favor de interntarlo de nuevo."
            });
            this.loading = false;
          }
        );
    }
  }

  pdf() {
    this._ciacService.Impresion(this.idsolicitud)
    /*.subscribe(
      data => { },
      err => {
      }
    );*/
  }

  handleSuccess(e) {
    this.captcha = true;
  }

  handleExpire(e) {
    this.captcha = false;
  }
}
